import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VoidPaymentsComponent } from './void-payments/void-payments.component';

const routes: Routes = [
	{
		path: 'reclassify-checks',
		loadChildren: () => import('./reclassify-checks/reclassify-checks.module').then((m) => m.ReclassifyChecksModule),
	},
	{
		path: 'void-payments',
		component: VoidPaymentsComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class CashManagementRoutingModule {}
